/* euroguard · Carrito lateral (sections/eg-cart-drawer.liquid)
   - Se abre desde [data-eg-cart-open] (icono de la cabecera) y con el evento «cart:refresh» que lanzan las páginas de
     producto al añadir (detail.open === false solo refresca).
   - Cantidades y eliminación con /cart/change.js pidiendo la sección re-renderizada (Section Rendering API).
   - Intercepta los formularios clásicos action="/cart/add" (plantilla de producto antigua) y añade por AJAX.
   - Guardia de ofertas: retira las líneas ligadas a una suscripción si desaparece el cartucho con plan
     (misma regla que pdp-offer-guard.js en la página del carrito).
   - Sugerencias «Completa tu pedido» con las recomendaciones de Shopify del primer producto del carrito.
   window.egCartDrawer = { open, close, refresh, add(items) } */
(function () {
  'use strict';
  if (window.__egCartDrawer) return;
  window.__egCartDrawer = true;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var api = null;

  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  function build(drawer) {
    var panel = $('.eg-cd__panel', drawer);
    var sectionId = drawer.getAttribute('data-section') || 'eg-cart-drawer';
    var root = drawer.getAttribute('data-root') || '/';
    var currency = drawer.getAttribute('data-currency') || 'EUR';
    var lastFocus = null, isOpen = false, pending = 0, inputTimer = null;

    /* ---------- utilidades ---------- */
    function setBusy(on) {
      pending += on ? 1 : -1;
      if (pending < 0) pending = 0;
      drawer.setAttribute('aria-busy', pending > 0 ? 'true' : 'false');
    }
    function showError(msg) {
      var el = $('[data-eg-cd-error]', drawer);
      if (!el) return;
      el.textContent = msg || drawer.getAttribute('data-error') || 'Error';
      el.hidden = false;
    }
    function clearError() { var el = $('[data-eg-cd-error]', drawer); if (el) { el.hidden = true; el.textContent = ''; } }
    /* Mismo formato que los precios en Liquid (Configuración › Moneda), p. ej. «€{{amount_with_comma_separator}}» */
    var moneyFormat = drawer.getAttribute('data-money-format') || '';
    function money(cents) {
      var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!m) {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: currency }).format(cents / 100); }
        catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
      }
      var key = m[1], decimals = key.indexOf('no_decimals') === -1 ? 2 : 0;
      var thousands = ',', decimal = '.';
      if (key.indexOf('comma_separator') > -1) { thousands = '.'; decimal = ','; }
      else if (key.indexOf('apostrophe_separator') > -1) { thousands = "'"; decimal = '.'; }
      else if (key.indexOf('period_and_space_separator') > -1) { thousands = ' '; decimal = '.'; }
      else if (key.indexOf('space_separator') > -1) { thousands = ' '; decimal = ','; }
      var fixed = (Math.round(Number(cents) || 0) / 100).toFixed(decimals).split('.');
      var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return moneyFormat.replace(m[0], decimals ? whole + decimal + fixed[1] : whole);
    }
    function updateCount(n) {
      $$('[data-cart-count]').forEach(function (el) {
        var was = el.textContent;
        el.textContent = n > 0 ? String(n) : '';
        if (el.classList.contains('eg-hdr__count') && String(n) !== was) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
      });
      $$('[data-eg-cart-open]').forEach(function (a) {
        if (!a.getAttribute('data-label')) a.setAttribute('data-label', (a.getAttribute('aria-label') || '').replace(/,\s*\d+$/, ''));
        a.setAttribute('aria-label', a.getAttribute('data-label') + (n > 0 ? ', ' + n : ''));
      });
    }
    /* Sustituye el contenido del cajón por el HTML re-renderizado de la sección */
    function swap(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-eg-cart-drawer]', doc), inner = fresh && $('[data-eg-cd-inner]', fresh);
      if (!inner) return false;
      $('[data-eg-cd-inner]', drawer).innerHTML = inner.innerHTML;
      var n = Number(fresh.getAttribute('data-count') || 0);
      drawer.setAttribute('data-count', String(n));
      updateCount(n);
      loadUpsell();
      return true;
    }
    function sectionUrl() { return root + (root.indexOf('?') > -1 ? '&' : '?') + 'sections=' + encodeURIComponent(sectionId); }
    function refresh() {
      setBusy(true);
      return fetch(sectionUrl(), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) { swap(data[sectionId] || ''); })
        .catch(function () { showError(); })
        .then(function () { setBusy(false); });
    }

    /* ---------- guardia de ofertas ligadas a suscripción ---------- */
    function guardChanges(cart) {
      var sources = ['eg-pdp-faucet', 'eg-pdp-undersink'], groups = {}, changes = [];
      (cart.items || []).forEach(function (item, i) {
        var p = item.properties || {};
        if (sources.indexOf(p._offer_source) === -1 || !p._offer_group) return;
        var g = groups[p._offer_group] || (groups[p._offer_group] = { main: [], addon: [] });
        g[p._offer_role === 'addon' ? 'addon' : 'main'].push({ item: item, line: i + 1 });
      });
      Object.keys(groups).forEach(function (k) {
        var g = groups[k];
        var hasSub = g.addon.some(function (a) { return a.item.selling_plan_allocation && a.item.quantity > 0; });
        g.main.forEach(function (m) {
          var p = m.item.properties || {};
          var free = m.item.final_line_price === 0 || m.item.original_price === 0;
          var tied = free || String(p._offer_requires_sub || '') === '1';
          if (tied && !hasSub) changes.push({ line: m.line, quantity: 0 });
          else if (tied && m.item.quantity > 1) changes.push({ line: m.line, quantity: 1 });
        });
      });
      return changes.sort(function (a, b) { return b.line - a.line; });
    }
    function applyGuard(cart) {
      var changes = guardChanges(cart);
      if (!changes.length) return Promise.resolve(cart);
      return changes.reduce(function (p, c) {
        return p.then(function () {
          return fetch(root + 'cart/change.js', { method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin', body: JSON.stringify(c) }).then(function (r) { return r.json(); });
        });
      }, Promise.resolve()).then(function (latest) { return latest || cart; });
    }

    /* ---------- cambios de cantidad ---------- */
    function change(key, quantity) {
      clearError(); setBusy(true);
      return fetch(root + 'cart/change.js', { method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin', body: JSON.stringify({ id: key, quantity: quantity, sections: sectionId }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok || res.data.status) throw new Error(res.data.description || res.data.message || '');
          var cart = res.data;
          if (guardChanges(cart).length) return applyGuard(cart).then(function () { return refresh(); });
          if (cart.sections && cart.sections[sectionId]) swap(cart.sections[sectionId]); else return refresh();
        })
        .catch(function (e) { var msg = e && e.message ? e.message : ''; return refresh().then(function () { showError(msg); }); })
        .then(function () { setBusy(false); });
    }
    function lineOf(el) { var li = el.closest('[data-eg-cd-line]'); return li ? li.getAttribute('data-eg-cd-line') : null; }
    drawer.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-eg-cd-close]');
      if (closeBtn) { e.preventDefault(); close(); return; }
      var step = e.target.closest('[data-eg-cd-qty]');
      if (step) {
        var input = $('[data-eg-cd-input]', step.parentElement), q = Math.max(0, (Number(input.value) || 0) + Number(step.getAttribute('data-eg-cd-qty')));
        input.value = q; change(lineOf(step), q); return;
      }
      var rm = e.target.closest('[data-eg-cd-remove]');
      if (rm) { change(lineOf(rm), 0); return; }
      var up = e.target.closest('[data-eg-cd-up-add]');
      if (up) { up.disabled = true; add([{ id: Number(up.getAttribute('data-eg-cd-up-add')), quantity: 1 }], { open: false }); }
    });
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-eg-cd-input]');
      if (!input) return;
      clearTimeout(inputTimer);
      var q = Math.max(0, Math.min(99, Number(input.value) || 0));
      inputTimer = setTimeout(function () { change(lineOf(input), q); }, 150);
    });

    /* ---------- añadir (formularios clásicos y sugerencias) ---------- */
    function add(items, opts) {
      opts = opts || {};
      clearError(); setBusy(true);
      return fetch(root + 'cart/add.js', { method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin', body: JSON.stringify({ items: items, sections: sectionId }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok || res.data.status) throw new Error(res.data.description || res.data.message || '');
          if (opts.open !== false) open({ noRefresh: true });
          if (res.data.sections && res.data.sections[sectionId]) swap(res.data.sections[sectionId]); else return refresh();
        })
        .catch(function (e) { if (opts.open !== false) open({ noRefresh: true }); showError(e && e.message ? e.message : ''); })
        .then(function () { setBusy(false); });
    }

    /* ---------- sugerencias ---------- */
    function loadUpsell() {
      var box = $('[data-eg-cd-upsell]', drawer), list = box && $('[data-eg-cd-upsell-list]', box);
      if (!box || !list || drawer.getAttribute('data-upsell') !== 'true') return;
      var lines = $$('[data-eg-cd-line]', drawer);
      if (!lines.length) { box.hidden = true; return; }
      var inCart = lines.map(function (l) { return l.getAttribute('data-product-id'); });
      fetch(root + 'recommendations/products.json?product_id=' + inCart[0] + '&limit=6&intent=related', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var items = (d.products || []).filter(function (p) { return p.available && inCart.indexOf(String(p.id)) === -1; }).slice(0, 3);
          if (!items.length) { box.hidden = true; return; }
          var label = drawer.getAttribute('data-upsell-add') || 'Ajouter';
          list.innerHTML = items.map(function (p) {
            var img = p.featured_image ? '<img src="' + escapeHtml(p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120') + '" alt="" loading="lazy">' : '<span></span>';
            var single = p.variants && p.variants.length === 1 && p.variants[0].available;
            var action = single ? '<button type="button" data-eg-cd-up-add="' + p.variants[0].id + '">' + escapeHtml(label) + '</button>' : '<a class="eg-cd__up-btn" href="' + escapeHtml(p.url) + '">' + escapeHtml(label) + '</a>';
            return '<li class="eg-cd__up">' + img + '<div><b>' + escapeHtml(p.title) + '</b><span>' + money(p.price) + '</span></div>' + action + '</li>';
          }).join('');
          box.hidden = false;
        })
        .catch(function () { box.hidden = true; });
    }

    /* ---------- abrir / cerrar ---------- */
    function open(opts) {
      opts = opts || {};
      if (!isOpen) {
        clearError();
        lastFocus = document.activeElement;
        drawer.dataset.open = 'true';
        document.documentElement.classList.add('eg-cd-open');
        isOpen = true;
        setTimeout(function () { var c = $('.eg-cd__close', drawer); (c || panel).focus({ preventScroll: true }); }, 60);
      }
      if (!opts.noRefresh) refresh();
    }
    function close() {
      if (!isOpen) return;
      drawer.dataset.open = 'false';
      document.documentElement.classList.remove('eg-cd-open');
      isOpen = false;
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    function handleKey(e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', panel).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    updateCount(Number(drawer.getAttribute('data-count') || 0));
    return { open: open, close: close, refresh: refresh, add: add, handleKey: handleKey, isOpen: function () { return isOpen; } };
  }

  function init() {
    var drawer = $('[data-eg-cart-drawer]');
    if (!drawer || drawer.dataset.egReady) return;
    drawer.dataset.egReady = '1';
    api = build(drawer);
    window.egCartDrawer = api;
    document.dispatchEvent(new CustomEvent('cart-drawer:ready'));
  }

  /* Escuchas globales, una sola vez; delegan en la instancia actual (se reconstruye en el editor de temas) */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-eg-cart-open]');
    if (!trigger || !api || document.body.hasAttribute('data-preview')) return;
    e.preventDefault(); api.open();
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!api || !form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.hasAttribute('data-eg-no-drawer') || document.body.hasAttribute('data-preview')) return;
    e.preventDefault();
    var fd = new FormData(form), item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1), properties: {} };
    if (fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));
    fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m) item.properties[m[1]] = v; });
    if (!Object.keys(item.properties).length) delete item.properties;
    var btn = form.querySelector('[type=submit]'); if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    api.add([item]).then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });
  document.addEventListener('keydown', function (e) { if (api) api.handleKey(e); });
  document.addEventListener('cart:refresh', function (e) {
    if (!api) return;
    var d = (e && e.detail) || {};
    if (d.open === false) api.refresh(); else api.open();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted && api) api.refresh(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) {
    var d = e.target && e.target.querySelector && e.target.querySelector('[data-eg-cart-drawer]');
    if (d) { delete d.dataset.egReady; init(); }
  });
  document.addEventListener('shopify:section:select', function (e) {
    var d = e.target && e.target.querySelector && e.target.querySelector('[data-eg-cart-drawer]');
    if (d && api) api.open({ noRefresh: true });
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var d = e.target && e.target.querySelector && e.target.querySelector('[data-eg-cart-drawer]');
    if (d && api) api.close();
  });
})();
